module.exports = __webpack_public_path__ + "media/images/orbit/timer-black-e2268124efd1dcd4fe527acff487af66ccad56632f2293409ed0ac38431faa95.png";